<template>
  <div class="topic-edit">
    <el-form ref="form" :model="form" label-width="120px" size="small">
      <div class="white-container">
        <el-form-item label="俱乐部名称：" prop="name" style="width: 500px">
          {{ form.name }}
        </el-form-item>

        <el-form-item label="俱乐部地区：" prop="region" style="width:300px">
          {{ form.region }}
        </el-form-item>

        <el-form-item v-if="form.id" label="是否主推：" prop="isRecommend" style="width: 500px; white-space: nowrap">
          {{ form.isRecommend === 0 ? '是' : '否' }}
        </el-form-item>

        <el-form-item v-if="form.id" label="是否官方俱乐部：" prop="isOfficialClub" style="width: 500px; white-space: nowrap">
          {{ form.isOfficialClub === 0 ? '是' : '否' }}
        </el-form-item>

        <el-form-item label="成员数量：" style="width: 100%">{{ form.memberNumber }}人</el-form-item>

        <el-form-item label="发起活动次数：" style="width: 100%">{{ form.eventNumber }}次</el-form-item>

        <el-form-item label="Leader姓名：" prop="leaderName" style="width: 500px">
          {{ form.leaderName }}
        </el-form-item>

        <el-form-item label="Slogan：" prop="slogan" style="width: 500px">
          {{ form.slogan }}
        </el-form-item>

        <el-form-item label="俱乐部介绍：" prop="description" style="width: 100%">
          {{ form.description }}
        </el-form-item>

        <el-form-item label="俱乐部头像：" prop="logo" class="image-config" style="width:100%">
          <img :src="form.logo" class="activity-img">
        </el-form-item>

        <el-form-item label="俱乐部leader企微二维码：" prop="qrCodeUrl" class="image-config" style="width:100%">
          <img :src="form.qrCodeUrl" class="activity-img">
        </el-form-item>

        <el-form-item v-if="form.id" style="width:100%;margin-top:80px;margin-left:-50px">
          <div class="flex btns">
            <el-button type="primary" @click="goBack">返回</el-button>
          </div>
        </el-form-item>
      </div>

    </el-form>
  </div>
</template>
<script>

export default {
  components: {},
  data() {
    return {
      form: {
        name: '',
        region: '',
        leaderName: '',
        slogan: '',
        description: '',
        eventNumber: 0,
        memberNumber: 0,
        isOfficialClub: 1,
        logo: '',
        id: null,
      },

      loading: false,
      id: null,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    const { query } = this.$route;
    const id = query.id;

    if (query.id) {
      this.id = id;
      this.getActivityDetail(id);
    }
    this.cancelText = query.id ? '查看' : '新增';
  },
  methods: {
    getActivityDetail(id) {
      this.$Api.rugby.clubDetail({ clubId: id }).then(res => {
        this.form = res;
      });
    },
    goBack() {
      this.$router.back(-1);
    },
  },
};

</script>
<style lang="less" scoped>
.btns {
  align-items: center;
  justify-content: center;
}
</style>
<style lang="less">
.topic-edit {
  .el-form-item--small.el-form-item {
    margin-bottom: 30px;
    .form-radio {
      line-height: 32px;
      height: 32px;
      align-items: center;
    }
    .el-checkbox__inner::after {
      border-right-width: 2.5px;
      border-bottom-width: 2.5px;
    }
    .el-checkbox__label {
      color: #494949;
    }
  }
  .coach-select-box + .el-form-item__error {
    top: unset !important;
    bottom: 43px !important;
  }
  .uploadImg-cont {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .uploader {
      margin-bottom: 30px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
  .form-icon {
    margin-left: 10px;
    .el-icon-close {
      color: #9b9b9b;
      cursor: pointer;
      &:hover {
        color: #000000;
      }
    }
  }

  .product-config,
  .image-config {
    .activity-img {
      width: 150px;
      height: 150px;
      border-radius: 6px;
    }
  }
  .lng-label .el-form-item__label {
    width: 50px !important;
  }
  .lng-label .el-form-item__content {
    margin-left: 50px !important;
  }
  .btn-form-item.el-form-item--small {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}
</style>

